import { Injectable } from '@angular/core';
import { DatasourceJobSettingsValidationService, DatasourceTableStoreModel } from '@y42/datasource';
import { JobHttpModel, JobSettingsValidationResult, JobSettingsValidationResults } from '@y42/job';
import { JobSettingsValidationFormatterService } from '@y42/job/shared';
import { IntegrationGitService } from '../../datasource/integration-git.service';
import { IntegrationStoreModel } from '../../datasource/integration.model';
import { IntegrationJobSettingsValidationType } from './integration-job-settings-validation.model';

@Injectable({ providedIn: 'root' })
export class IntegrationJobSettingsValidationService extends DatasourceJobSettingsValidationService<IntegrationStoreModel> {
  constructor(
    private readonly integrationGitService: IntegrationGitService,
    private readonly jobSettingsValidationFormatterService: JobSettingsValidationFormatterService,
  ) {
    super();
  }

  override validate(
    job: JobHttpModel,
    table: DatasourceTableStoreModel,
    datasource: IntegrationStoreModel,
  ): JobSettingsValidationResults<IntegrationJobSettingsValidationType> {
    return {
      ...super.validate(job, table, datasource),
      source_credentials: this.validateCredentials(job, datasource),
    };
  }

  private validateCredentials(job: JobHttpModel, datasource: IntegrationStoreModel): JobSettingsValidationResult {
    const currentCredentials = datasource.secret ?? '';
    const jobSourceCredentials = job.request?.integration_secret_id ?? '';
    return {
      entityPath: datasource.$path,
      filePath: this.integrationGitService.getCredentialsPath(datasource.$name ?? ''),
      content1AsJson: { data: currentCredentials },
      content2AsJson: { data: jobSourceCredentials },
      isValid:
        this.jobSettingsValidationFormatterService.sanitizeCredentials(currentCredentials) ===
        this.jobSettingsValidationFormatterService.sanitizeCredentials(jobSourceCredentials),
    };
  }
}
